/**
 * @generated SignedSource<<0afb180b1cf9bf1d22481de80cacb833>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LocationBlock_contentBlock$data = {
  readonly address: {
    readonly " $fragmentSpreads": FragmentRefs<"Address_address">;
  };
  readonly coordinates: {
    readonly latitude: number;
    readonly longitude: number;
  };
  readonly emailLabel: string;
  readonly faxLabel: string;
  readonly phoneLabel: string;
  readonly " $fragmentType": "LocationBlock_contentBlock";
};
export type LocationBlock_contentBlock$key = {
  readonly " $data"?: LocationBlock_contentBlock$data;
  readonly " $fragmentSpreads": FragmentRefs<"LocationBlock_contentBlock">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LocationBlock_contentBlock",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "faxLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Address_address"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Coordinates",
      "kind": "LinkedField",
      "name": "coordinates",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "latitude",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "longitude",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LocationBlock",
  "abstractKey": null
};

(node as any).hash = "94ea184bfccbb4169be0c2324359a995";

export default node;
